// common
import { createWebHistory, createRouter } from 'vue-router'
import AuthGuard from './services/authGuard'
import Login from './view/auth/login'
import Forgot from './view/auth/forgot'
import NotFound from './view/auth/404'

// users
// import ExplorePage from './view/users/explore/explorePage';
// import ExplorePage from './view/users/explore/exp'
import ConnectionTypes from './view/users/connectionType/connectionTypes'
import AreaPage from './view/users/area/Area'
import ServicePage from './view/users/service_type/ServiceType'
import CustomerCreate from './view/customer/customer_add'
import CustomerEdit from './view/customer/customer_edit'
import CustomerDetails from './view/customer/customer_details'
import CustomerList from './view/customer/customer_list'
import CustomerInvoiceRecord from './view/customerPanel/invoiceRecords'
import CustomerAccountRecord from './view/customerPanel/accountRecords.vue'
import CustomerServiceList from './view/customer/customer_services'
import CustomerServiceListWithCustomerId from './view/customer/customer_services_with_customer_id'
import CustomerServices from './view/customer/customer_services_individual'
import EmployeeList from './view/employee/index'
import employeeCustomerAssigned from './view/employee/employee_customer'
import popList from './view/pop/index'
import InvoiceList from './view/invoice/list'
import InvoiceListByDistrict from './view/invoice/list2'
import InvoiceDetails from './view/invoice/invoice_details.vue'
import manualInvoiceCreate from './view/invoice/manual_invoice'
import PaymentRecieve from './view/payment_recieve'
import CustormerOwnProfileDetails from './view/customer/customer_own_profile.vue'
import CollectionReport from './view/report/collection'
import DueReport from './view/report/due'
import AgeReport from './view/report/age'
import AccountReport from './view/report/accountStatement'

// local
import ls from 'localstorage-slim'
import { AES } from 'crypto-js'
import encUTF8 from 'crypto-js/enc-utf8'

ls.config.encrypt = true
ls.config.secret = 'my-secret-password'
ls.config.decrypter = (data, secret) => {
  try {
    return JSON.parse(AES.decrypt(data, secret).toString(encUTF8))
  } catch (e) {
    // incorrect secret, return the encrypted data instead / or null
    return data // or return null;
  }
}

// let user = this.$store.state.auth.user
// console.log(this.$store.state.auth.user)
const routes = [
  {
    path: '/',
    component: Login,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/recover',
    redirect: '/',
  },
  {
    path: '/forgot',
    component: Forgot,
  },
  {
    path: '/invoice-records',
    component: CustomerInvoiceRecord,
  },
  {
    path: '/account-records',
    component: CustomerAccountRecord,
  },
  {
    path: '/dashboard',
    component: CustomerInvoiceRecord,
  },
  {
    path: '/explore',
    name: 'ExplorePage',
    component: ConnectionTypes,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/connection/types',
    name: 'ConnectionTypes',
    component: ConnectionTypes,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/area/list',
    name: 'AreaPage',
    component: AreaPage,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/service_type/list',
    name: 'ServicePage',
    component: ServicePage,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/customer/create',
    name: 'CustomerCreate',
    component: CustomerCreate,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/customer/edit/:id',
    name: 'CustomerEdit',
    component: CustomerEdit,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/customer/details/:id',
    name: 'CustomerDetails',
    component: CustomerDetails,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/profile/',
    name: 'CustormerOwnProfileDetails', 
    component: CustormerOwnProfileDetails,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/customer/list',
    name: 'CustomerList',
    component: CustomerList,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/customer/service/list',
    name: 'CustomerServiceList',
    component: CustomerServiceList,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/customer/service/list/:id',
    name: 'CustomerServiceListWithCustomerId',
    component: CustomerServiceListWithCustomerId,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/customer-service/:id',
    name: 'CustomerServices',
    component: CustomerServices,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/employee/list',
    name: 'EmployeeList',
    component: EmployeeList,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/employee/assigned_customer',
    name: 'employeeCustomerAssigned',
    component: employeeCustomerAssigned,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/pop/types',
    name: 'popList',
    component: popList,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/invoice-list',
    name: 'InvoiceList',
    component: InvoiceList,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/invoice-list-district',
    name: 'InvoiceListByDistrict',
    component: InvoiceListByDistrict,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/invoice-details/:id',
    name: 'InvoiceDetails',
    component: InvoiceDetails,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/create/manual-invoice',
    name: 'manualInvoiceCreate',
    component: manualInvoiceCreate,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/operation/payment-recieve',
    name: 'PaymentRecieve',
    component: PaymentRecieve,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/report/collection',
    name: 'CollectionReport',
    component: CollectionReport,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/report/age',
    name: 'AgeReport',
    component: AgeReport,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/report/account-statement',
    name: 'AccountReport',
    component: AccountReport,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/report/due',
    name: 'DueReport',
    component: DueReport,
    beforeEach: AuthGuard.isAdmin_SuperAdmin,
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
})

// trying to access a restricted page + not logged in
router.beforeEach(async (to, from, next) => {
  // const publicPages = [
  //   '/login',
  //   '/home',
  //   '/forgot',
  //   '/:catchAll(.*)',
  // ];
  // // const { authorize } = to.meta;
  // const authRequired = !publicPages.includes(to.path);
  // // const loggedIn = localStorage.getItem('user');
  // const loggedIn = JSON.parse(ls.get('user'));
  // redirect to login page
  if (window.location.href.indexOf('recover') > -1) {
    next()
  } else if (window.location.href.indexOf('account-verify') > -1) {
    next()
  }
  // else if (authRequired && !loggedIn) {
  //   next('/login');
  // }
  else {
    next()
  }
})

export default router
